// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y1uFpHm6UMYeG7XZeOH9{width:256px;display:flex;flex-direction:column}.QEdlOzDwVuNShPiP3XMI{flex:1 1 100%}
`, "",{"version":3,"sources":["webpack://./src/layouts/components/notification-sidenav/notification-sidenav.module.scss"],"names":[],"mappings":"AAAA,sBACI,WAAY,CACZ,YAAa,CACb,qBAAsB,CACzB,sBAGG,aAAc","sourcesContent":[".portal-notification-sidenav {\r\n    width: 256px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.portal-notification-sidenav__content {\r\n    flex: 1 1 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"portal-notification-sidenav": `Y1uFpHm6UMYeG7XZeOH9`,
	"portal-notification-sidenav__content": `QEdlOzDwVuNShPiP3XMI`
};
export default ___CSS_LOADER_EXPORT___;
